import './GranDBanner.css'
import grandLogo from '../../assets/grand/grand-logo-white.png'
import { Flex, Stack } from '@mantine/core'
import { Link } from 'react-router-dom'
import SectionTitle from '../../components/SectionTitle/SectionTitle'
export default function GranDBanner() {
    return <section className='GranDBanner-main-container'>


        <Stack
            classNames={{ root: "GranDBanner--text-wrapper" }}>
            <SectionTitle
                upText='Grandes animales'
            >
                <h2 className="sectionTitle-downText">Especializate en <strong>clínica, cirugía y producción</strong> de grandes animales</h2>

            </SectionTitle>
            <h5 className='GranDBanner--subheading'>Formación práctica para aplicar en tu día a día. <strong>Contenidos actualizados</strong> compartidos por <strong>profesionales</strong> del sector</h5>

            <Flex w='100%' justify='start' mt={16}>
                <Link to="/grand" className="GranDBanner-cta ">
                    Ver todos los programas
                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </Link>
            </Flex>
        </Stack>
        <figure className='GranDBanner--logo-container'>
            <img className='GranDBanner--logoImage' src={grandLogo} alt="GranD Logo" />
        </figure>
    </section>
}